<template>
  <h1>Subscriptions Component</h1>
</template>

<script lang="ts" setup></script>
